import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { PageContent, Link, Button } from 'nallian-shared-ui/lib/components';
import { Table, Actions, Params, Menu } from 'nallian-table-builder-ui';
import HasRight from 'nallian-shared-ui/lib/layout/rights/HasRight';
import {
  INFINITE_SCROLL,
  COMMUNITY_ROLES_RESOURCE,
  ACTIONS,
  COMMUNITY_TAB_ACTIONS,
  COMMUNITY_DETAIL_TABS,
} from '../../constants';
import NewCommunityRole from './NewCommunityRole';
import EditCommunityRole from './EditCommunityRole';
import CommunityRoleOrganisations from './CommunityRoleOrganisations';
import apiRoutes from '../../../../app/api/routes';

const CommunityRolesOverview = () => {
  const { id, action, actionId } = useParams();
  const { t } = useTranslation();

  return (
    <>
      <PageContent>
        <HasRight right="COMMUNITYROLES.MANAGE.ALL">
          <NewCommunityRole open={id && action && !actionId} />
          <EditCommunityRole open={id && action === COMMUNITY_TAB_ACTIONS.EDIT_ROLE && actionId} />
          <CommunityRoleOrganisations
            open={id && action === COMMUNITY_TAB_ACTIONS.VIEW_ORGANISATIONS && actionId}
          />
          <Link
            to={`/communities/edit/${id}/${COMMUNITY_DETAIL_TABS.ROLES}/${COMMUNITY_TAB_ACTIONS.NEW_ROLE}`}
          >
            <Button btnprimary icon="plus" content={t('addRole')} />
          </Link>
        </HasRight>
        <Table
          url={apiRoutes.communityRoles2(id)}
          infiniteScroll={INFINITE_SCROLL}
          resource={COMMUNITY_ROLES_RESOURCE}
          rootTableProperty="communityRoles"
          idProp="tag"
          pageSize={50}
          noUserSettings
          resizable
          filtered
          sorted
        >
          <Actions.Link
            width="2.5rem"
            align="center"
            icon="eye"
            hasRight="COMMUNITYROLES.MANAGE.ALL"
            url={`/communities/${ACTIONS.EDIT}/${id}/${COMMUNITY_DETAIL_TABS.ROLES}/${COMMUNITY_TAB_ACTIONS.EDIT_ROLE}/:tag`}
          />
          <Params.String name="name" width="16rem" minWidth="16rem" grow />
          <Params.String name="tag" width="16rem" minWidth="16rem" grow />
          <Params.String name="alias" width="16rem" minWidth="16rem" grow />
          <Menu width="3.5rem" align="center" hasRight="COMMUNITYROLES.MANAGE.ALL">
            <Actions.Link
              label="edit"
              icon="edit"
              url={`/communities/${ACTIONS.EDIT}/${id}/${COMMUNITY_DETAIL_TABS.ROLES}/${COMMUNITY_TAB_ACTIONS.EDIT_ROLE}/:tag`}
            />
            <Actions.Link
              label="viewOrganisations"
              icon="eye"
              url={`/communities/${ACTIONS.EDIT}/${id}/${COMMUNITY_DETAIL_TABS.ROLES}/${COMMUNITY_TAB_ACTIONS.VIEW_ORGANISATIONS}/:tag`}
            />
            <Actions.Delete url={apiRoutes.communityRoles2(id, ':tag')} />
          </Menu>
        </Table>
      </PageContent>
    </>
  );
};

export default CommunityRolesOverview;
